module.exports = __webpack_public_path__ + "static/media/icon_deac.9843b133.png";